import React, { PureComponent } from 'react';

import InnerRanking from '../InnerRanking';

class Result extends PureComponent {
  renderEmpty() {
    return (
      <div className="result empty">
        <div className="result__header">
          <div className="result__header-top">
            <div className="result__header-name">Ihr Ort</div>
          </div>
        </div>
        <InnerRanking items={this.props.dataInfo} empty />
      </div>
    );
  }

  render() {
    const { data, dataInfo, germanyData } = this.props;

    if (!data) {
      return this.renderEmpty();
    }

    const items = dataInfo.map(col => ({
      ...col,
      value: data[col.key],
    }));

    const greenestIndex = items.reduce((res, item) => {
      const isAbove = item.key !== 'muell_pk' && item.value > germanyData[item.key];
      const isBelow = item.key === 'muell_pk' && item.value < germanyData[item.key];

      if (isAbove || isBelow) {
        res++;
      }

      return res;
    }, 0);

    return (
      <div className="result ranking">
        <div className="result__header">
          <div className="result__header-top">
            <div className="result__header-rank">{data.rank}</div>
            <div className="result__header-name">{data.Kreis}</div>
          </div>
          <div className="result__header-bottom">
            <div className="result__header-state">{data.Bundesland}</div>
            <div className="result__header-count"><strong className="index-value">{data.group}</strong><span className="index-max">/5</span></div>
          </div>
        </div>
        <InnerRanking items={items} greenVoters={data.Gruene} />
      </div>
    );
  }
}

export default Result;
